export default "__VITE_ASSET__CEmmRLNL__"